/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import apiService from './index'

export const getAllHomeTags = async (userId: string) => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/tag/user/${userId}`)
}

export const getTagsByBoardId = async (boardId: string, type?: string, inUse?: boolean) => {
  const params: string[] = []
  if (type) params.push(`type=${type}`)
  if (inUse) params.push('inUse=true')
  const query = params.length ? `?${params.join('&')}` : ''
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/tag/board/${boardId}${query}`)
}

export const createNewTag = async (name: string, boardId: string) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/tag`, {
    name: name,
    boardId: boardId,
  })
}
